import { render, staticRenderFns } from "./EmployeePreviewCardNew.vue?vue&type=template&id=61a66193&scoped=true"
import script from "./EmployeePreviewCardNew.vue?vue&type=script&lang=js"
export * from "./EmployeePreviewCardNew.vue?vue&type=script&lang=js"
import style0 from "./EmployeePreviewCardNew.vue?vue&type=style&index=0&id=61a66193&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a66193",
  null
  
)

export default component.exports